import TOLGEE_GLOBALS from './tolgeeGlobals'

export const getTerritorySubtitleForTable = (item, t) => {
  if (['SavedPostSearch', 'GlobalTopic'].includes(item?.__typename)) {
    return []
  }

  if (item?.__typename === 'IndustryTopic') {
    return [
      {
        name: t(TOLGEE_GLOBALS.category),
      },
    ]
  }

  if (item?.__typename === 'Niche') {
    if (!item?.allParents?.length) {
      return []
    }

    return [
      {
        name: item?.allParents?.[0]?.name,
      },
    ]
  }

  if (item?.__typename === 'Subtopic') {
    const territoryLanguage = item?.language

    if (territoryLanguage === 'all') {
      const newParentName = `${t(TOLGEE_GLOBALS.music)} - ${item?.allParents?.[0]?.name}`
      return [
        {
          ...item?.allParents?.[0],
          name: newParentName,
        },
      ]
    }

    const languageLabel = `${t(TOLGEE_GLOBALS?.[territoryLanguage])} - `

    const newParentName = `${territoryLanguage ? languageLabel : ''}${item?.allParents?.[0]?.name}`

    return [
      {
        ...item?.allParents?.[0],
        name: newParentName,
      },
    ]
  }

  if (item?.__typename === 'Topic') {
    const territoryLanguage = item?.language

    if (territoryLanguage === 'all') {
      const newParentName = `${t(TOLGEE_GLOBALS.music)}`
      return [
        {
          name: newParentName,
        },
      ]
    }

    const languageLabel = `${t(TOLGEE_GLOBALS?.[territoryLanguage])} - `
    const newParentName = `${territoryLanguage ? languageLabel : ''}${item?.category?.title}`
    return [
      {
        name: newParentName,
      },
    ]
  }

  return []
}
